var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loadingShow)?_c('div',{staticClass:"loading"},[_c('van-loading',{attrs:{"size":"64px","text-size":"30px","vertical":""}},[_vm._v(_vm._s(_vm.loadingTitle))])],1):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }